// jting: These filters maintain alphabetical order for the most part
export const DEFAULT_FILTERS = {
    section: {
        key: 'section',
        displayTitle: 'Section',
        shouldDisplayKey: false,
        aggregationKey: 'section',
        visible: true,
        values: [
            { label: 'Inbox', value: 'inbox' },
            { label: 'Pending', value: 'pending' },
            { label: 'Completed', value: 'completed' }
        ],
        multi: false
    },
    state: {
        key: 'state',
        displayTitle: 'Status',
        shouldDisplayKey: false,
        aggregationKey: 'state',
        visible: true,
        values: [
            { label: 'Unapproved', value: 'new' },
            { label: 'Approved', value: 'approved' },
            { label: 'Denied and Resubmittable', value: 'denied_and_resubmittable' },
            { label: 'Denied Permanently', value: 'denied_permanently' },
            { label: 'Manager Approved', value: 'manager_approved' }
        ],
        multi: true
    },
    reviewed_by: {
        key: 'reviewed_by',
        displayTitle: 'Auto Approved',
        shouldDisplayKey: false,
        aggregationKey: 'reviewed_by',
        visible: true,
        values: [{ label: 'Auto Approved', value: 'auto' }],
        multi: false
    },
    amount: {
        key: 'amount',
        displayTitle: 'Amount',
        shouldDisplayKey: true,
        visible: true,
        multi: false
    },
    billable: {
        key: 'billable',
        displayTitle: 'Billable',
        shouldDisplayKey: false,
        aggregationKey: 'billablee',
        visible: true,
        values: [
            { label: 'Billable: True', value: true },
            { label: 'Billable: False', value: false }
        ],
        multi: false
    },
    resubmitted: {
        key: 'resubmitted',
        displayTitle: 'Resubmitted',
        shouldDisplayKey: false,
        aggregationKey: 'resubmitted',
        visible: true,
        values: [
            { label: 'Resubmitted: True', value: true },
            { label: 'Resubmitted: False', value: false }
        ],
        multi: false
    },
    category_id: {
        key: 'category_id',
        displayTitle: 'Category',
        shouldDisplayKey: false,
        aggregationKey: 'category_id',
        visible: true,
        multi: true
    },
    current_reviewer_user_profile_id: {
        key: 'current_reviewer_user_profile_id',
        aggregationKey: 'current_reviewer_user_profile_id',
        shouldDisplayKey: true,
        displayTitle: 'Current Reviewer',
        visible: true,
        multi: true
    },
    international: {
        key: 'international',
        displayTitle: 'International',
        shouldDisplayKey: false,
        aggregationKey: 'international',
        visible: true,
        values: [
            { label: 'International: True', value: true },
            { label: 'International: False', value: false }
        ],
        multi: false
    },
    manager_id: {
        key: 'manager_id',
        displayTitle: 'Manager',
        shouldDisplayKey: true,
        visible: true,
        multi: true
    },
    vendor_unicode: {
        key: 'vendor_unicode',
        displayTitle: 'Merchant',
        shouldDisplayKey: false,
        aggregationKey: 'vendor_unicode',
        visible: true,
        multi: true
    },
    payment_status: {
        key: 'payment_status',
        aggregationKey: 'payment_status',
        shouldDisplayKey: false,
        displayTitle: 'Payment Status',
        visible: true,
        values: [
            { label: 'Paid', value: 'paid' },
            { label: 'Processing', value: 'processing' }
        ],
        multi: false
    },
    receipt: {
        key: 'receipt',
        displayTitle: 'Receipt',
        shouldDisplayKey: false,
        aggregationKey: 'receipt',
        visible: true,
        values: [
            { label: 'Receipt: True', value: true },
            { label: 'Receipt: False', value: false }
        ],
        multi: false
    },
    reimbursable: {
        key: 'reimbursable',
        displayTitle: 'Reimbursable',
        shouldDisplayKey: false,
        aggregationKey: 'reimbursable',
        visible: true,
        values: [
            { label: 'Reimbursable: True', value: true },
            { label: 'Reimbursable: False', value: false }
        ],
        multi: false
    },
    user_id: {
        key: 'user_id',
        aggregationKey: 'user_id',
        shouldDisplayKey: false,
        displayTitle: 'User',
        visible: true,
        multi: true
    },
    warnings: {
        key: 'warnings',
        displayTitle: 'Warnings',
        shouldDisplayKey: false,
        aggregationKey: 'warnings',
        visible: true,
        values: [
            { label: 'Warnings: True', value: true },
            { label: 'Warnings: False', value: false }
        ],
        multi: false
    },
    program_id: {
        key: 'program_id',
        displayTitle: 'Card Program',
        shouldDisplayKey: false,
        aggregationKey: 'program_id',
        visible: true,
        multi: true
    }
};
export const DEFAULT_ACTIVE_FILTERS = {
    general: {},
    date: {}
};
